var _defs, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8, _line9, _line10, _line11, _line12, _line13, _line14, _line15, _line16, _line17, _line18, _line19, _line20, _line21, _line22, _line23, _line24, _line25, _line26, _line27, _line28, _line29, _line30, _line31, _line32, _line33, _line34, _line35, _line36, _line37, _line38, _line39, _path, _path2, _polygon, _polygon2, _polygon3, _polygon4, _line40, _line41, _line42, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _polygon5, _polygon6, _path14, _path15;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCpPosterIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 140,
    height: 140,
    viewBox: "0 0 140 140",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.c,.d,.g,.i{fill:none;}.b{fill:#efefef;}.c,.d{stroke:#e5e5e5;}.c,.d,.g,.h,.i{stroke-linecap:round;stroke-linejoin:round;stroke-width:2px;}.d,.e,.f,.g,.h,.j,.k,.l,.m,.n{fill-rule:evenodd;}.e,.n{fill:#3c3c46;}.e{opacity:0.15;}.f{fill:#89d9fb;}.g,.h,.i{stroke:#3c3c46;}.h,.l{fill:#ffefe0;}.j{fill:#fff;}.k{fill:#1d70b6;}.m{fill:#3ca4ef;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "CP-poster-icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 140,
    height: 140
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "b",
    x: 91.67,
    y: 5,
    width: 43.33,
    height: 18.57
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "b",
    x: 26.67,
    y: 23.57,
    width: 43.33,
    height: 18.57
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "b",
    x: 5,
    y: 60.71,
    width: 21.67,
    height: 18.57
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "b",
    x: 70,
    y: 60.71,
    width: 43.33,
    height: 18.57
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    className: "b",
    x: 26.67,
    y: 97.86,
    width: 43.33,
    height: 18.57
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    className: "b",
    x: 91.67,
    y: 116.43,
    width: 43.33,
    height: 18.57
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "c",
    x1: 135,
    y1: 116.43,
    x2: 5,
    y2: 116.43
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "c",
    x1: 48.33,
    y1: 116.43,
    x2: 48.33,
    y2: 135
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "c",
    x1: 91.67,
    y1: 116.43,
    x2: 91.67,
    y2: 135
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "c",
    x1: 135,
    y1: 116.43,
    x2: 135,
    y2: 135
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    className: "c",
    x1: 5,
    y1: 116.43,
    x2: 5,
    y2: 135
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    className: "c",
    x1: 70,
    y1: 97.86,
    x2: 70,
    y2: 116.43
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    className: "c",
    x1: 113.33,
    y1: 97.86,
    x2: 113.33,
    y2: 116.43
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    className: "c",
    x1: 26.67,
    y1: 97.86,
    x2: 26.67,
    y2: 116.43
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    className: "c",
    x1: 135,
    y1: 97.86,
    x2: 5,
    y2: 97.86
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    className: "c",
    x1: 5,
    y1: 97.86,
    x2: 5,
    y2: 116.43
  })), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    className: "c",
    x1: 48.33,
    y1: 79.29,
    x2: 48.33,
    y2: 97.86
  })), _line12 || (_line12 = /*#__PURE__*/React.createElement("line", {
    className: "c",
    x1: 91.67,
    y1: 79.29,
    x2: 91.67,
    y2: 97.86
  })), _line13 || (_line13 = /*#__PURE__*/React.createElement("line", {
    className: "c",
    x1: 135,
    y1: 79.29,
    x2: 135,
    y2: 97.86
  })), _line14 || (_line14 = /*#__PURE__*/React.createElement("line", {
    className: "c",
    x1: 5,
    y1: 79.29,
    x2: 5,
    y2: 97.86
  })), _line15 || (_line15 = /*#__PURE__*/React.createElement("line", {
    className: "c",
    x1: 70,
    y1: 60.71,
    x2: 70,
    y2: 79.29
  })), _line16 || (_line16 = /*#__PURE__*/React.createElement("line", {
    className: "c",
    x1: 113.33,
    y1: 60.71,
    x2: 113.33,
    y2: 79.29
  })), _line17 || (_line17 = /*#__PURE__*/React.createElement("line", {
    className: "c",
    x1: 26.67,
    y1: 60.71,
    x2: 26.67,
    y2: 79.29
  })), _line18 || (_line18 = /*#__PURE__*/React.createElement("line", {
    className: "c",
    x1: 135,
    y1: 60.71,
    x2: 5,
    y2: 60.71
  })), _line19 || (_line19 = /*#__PURE__*/React.createElement("line", {
    className: "c",
    x1: 5,
    y1: 60.71,
    x2: 5,
    y2: 79.29
  })), _line20 || (_line20 = /*#__PURE__*/React.createElement("line", {
    className: "c",
    x1: 135,
    y1: 42.14,
    x2: 5,
    y2: 42.14
  })), _line21 || (_line21 = /*#__PURE__*/React.createElement("line", {
    className: "c",
    x1: 48.33,
    y1: 42.14,
    x2: 48.33,
    y2: 60.71
  })), _line22 || (_line22 = /*#__PURE__*/React.createElement("line", {
    className: "c",
    x1: 91.67,
    y1: 42.14,
    x2: 91.67,
    y2: 60.71
  })), _line23 || (_line23 = /*#__PURE__*/React.createElement("line", {
    className: "c",
    x1: 135,
    y1: 42.14,
    x2: 135,
    y2: 60.71
  })), _line24 || (_line24 = /*#__PURE__*/React.createElement("line", {
    className: "c",
    x1: 5,
    y1: 42.14,
    x2: 5,
    y2: 60.71
  })), _line25 || (_line25 = /*#__PURE__*/React.createElement("line", {
    className: "c",
    x1: 70,
    y1: 23.57,
    x2: 70,
    y2: 42.14
  })), _line26 || (_line26 = /*#__PURE__*/React.createElement("line", {
    className: "c",
    x1: 113.33,
    y1: 23.57,
    x2: 113.33,
    y2: 42.14
  })), _line27 || (_line27 = /*#__PURE__*/React.createElement("line", {
    className: "c",
    x1: 26.67,
    y1: 23.57,
    x2: 26.67,
    y2: 42.14
  })), _line28 || (_line28 = /*#__PURE__*/React.createElement("line", {
    className: "c",
    x1: 135,
    y1: 23.57,
    x2: 5,
    y2: 23.57
  })), _line29 || (_line29 = /*#__PURE__*/React.createElement("line", {
    className: "c",
    x1: 5,
    y1: 23.57,
    x2: 5,
    y2: 42.14
  })), _line30 || (_line30 = /*#__PURE__*/React.createElement("line", {
    className: "c",
    x1: 60.68,
    y1: 5,
    x2: 5,
    y2: 5
  })), _line31 || (_line31 = /*#__PURE__*/React.createElement("line", {
    className: "c",
    x1: 48.33,
    y1: 5,
    x2: 48.33,
    y2: 23.57
  })), _line32 || (_line32 = /*#__PURE__*/React.createElement("line", {
    className: "c",
    x1: 91.67,
    y1: 5,
    x2: 91.67,
    y2: 23.57
  })), _line33 || (_line33 = /*#__PURE__*/React.createElement("line", {
    className: "c",
    x1: 135,
    y1: 5,
    x2: 135,
    y2: 23.57
  })), _line34 || (_line34 = /*#__PURE__*/React.createElement("line", {
    className: "c",
    x1: 5,
    y1: 5,
    x2: 5,
    y2: 23.57
  })), _line35 || (_line35 = /*#__PURE__*/React.createElement("line", {
    className: "c",
    x1: 135,
    y1: 97.86,
    x2: 135,
    y2: 116.43
  })), _line36 || (_line36 = /*#__PURE__*/React.createElement("line", {
    className: "c",
    x1: 135,
    y1: 60.71,
    x2: 135,
    y2: 79.29
  })), _line37 || (_line37 = /*#__PURE__*/React.createElement("line", {
    className: "c",
    x1: 135,
    y1: 23.57,
    x2: 135,
    y2: 42.14
  })), _line38 || (_line38 = /*#__PURE__*/React.createElement("line", {
    className: "c",
    x1: 135,
    y1: 5,
    x2: 79.32,
    y2: 5
  })), _line39 || (_line39 = /*#__PURE__*/React.createElement("line", {
    className: "c",
    x1: 73.32,
    y1: 5,
    x2: 66.68,
    y2: 5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M105.51,135H5m130,0H124.15m-6,0h-6.64"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M31.53,79.29H5m130,0H44.16m-5,0H36.52"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "e",
    points: "38.75 23.28 110.81 23.28 110.81 109.16 93.7 126.28 38.75 126.28 38.75 23.28"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "f",
    points: "33.75 18.29 105.82 18.29 105.82 104.16 88.7 121.28 33.75 121.28 33.75 18.29"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "g",
    points: "33.75 18.29 105.82 18.29 105.82 104.16 88.7 121.28 33.75 121.28 33.75 18.29"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "h",
    points: "88.7 121.28 88.7 104.16 105.82 104.16 88.7 121.28"
  })), _line40 || (_line40 = /*#__PURE__*/React.createElement("line", {
    className: "i",
    x1: 65.19,
    y1: 106.75,
    x2: 74.37,
    y2: 106.75
  })), _line41 || (_line41 = /*#__PURE__*/React.createElement("line", {
    className: "i",
    x1: 62.9,
    y1: 101.8,
    x2: 76.66,
    y2: 101.8
  })), _line42 || (_line42 = /*#__PURE__*/React.createElement("line", {
    className: "i",
    x1: 59.47,
    y1: 96.86,
    x2: 80.1,
    y2: 96.86
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M69.9,30.57s-12.6.1-12.6,12.73v4.94S72,45.22,74,41.07c0,0,.19,5.28,8.55,6.82C82.56,47.89,85.26,30.57,69.9,30.57Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M55.71,71.15l0,0a9.25,9.25,0,0,0-5.77,9v6.92h6V79.86a.64.64,0,1,1,1.28,0V88H66L60.49,69.16Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M85.41,71.95a7.73,7.73,0,0,0-1.52-.78l0,0-4.56-1.9-5,17.87h8.13V79.86a.64.64,0,0,1,1.28,0v7.26h6V80.2A9.3,9.3,0,0,0,85.41,71.95Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M74.17,42.57,74,42.12l-.33.35c-4,4.16-10.16,5-12.63,5.12l-.3,0v6.92a8.23,8.23,0,0,0,8.22,8.22h1.92a8.23,8.23,0,0,0,8.22-8.22V47.48l-.21-.07a8.37,8.37,0,0,1-4.7-4.84Zm-5.44,8.78a.64.64,0,1,1,1.28,0v2.47h1a.64.64,0,1,1,0,1.28H69.37a.64.64,0,0,1-.64-.64V51.34Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M80.74,48.58l-.38-.07v5.81l.38-.07a2.89,2.89,0,0,0,0-5.67Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M73.65,63.63l-.4.1a9.5,9.5,0,0,1-2.39.3H68.94a9.5,9.5,0,0,1-2.39-.3l-.4-.1V67.2a.63.63,0,0,1,0,.1l0,.16,3.74,3.65,3.78-3.93V63.63Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M59.44,54.32V48.51l-.38.07a2.89,2.89,0,0,0,0,5.67Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M75.11,76.89a1,1,0,0,1-.57-.19l-1.08-.79-.68,1.81.91,5.62,1.83-6.55-.19.07Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M75.24,67.2a1,1,0,0,1,0,.12,1,1,0,0,1-.26.78l-3.69,3.83,3.47,2.55,2.81-5.77-2.32-1.53Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M67,77.74l-.78-1.86-1.12.82a1,1,0,0,1-.57.19l-.23,0h0l1.81,6.45Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M62.1,68.71l2.81,5.77,3.49-2.57-3.55-3.46a6.51,6.51,0,0,1-.29-1.25v-.11Z"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "m",
    points: "71.15 78.39 68.65 78.39 67.27 86.99 72.53 86.99 71.15 78.39"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    className: "m",
    points: "71.27 76.86 72.09 74.67 69.83 73 67.58 74.65 68.51 76.86 71.27 76.86"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M86.27,70.63h0a9.43,9.43,0,0,0-1.84-.94L79.1,67.46,75.33,65l-.11-.06V63.3a9.82,9.82,0,0,0,5.35-7.44,4.46,4.46,0,0,0,2.93-7.45V42.7A13.08,13.08,0,0,0,70.43,29.63h-1A13.08,13.08,0,0,0,56.36,42.7v5.65a4.46,4.46,0,0,0,2.87,7.52,9.82,9.82,0,0,0,5.35,7.44v1.51L60.65,67.4l-.16,0-5.37,2.24a10.48,10.48,0,0,0-3.41,2.18,11.07,11.07,0,0,0-3.4,8.33v7.55a.94.94,0,0,0,.94.94H60.33a.94.94,0,1,0,0-1.88H57.44v-7a.94.94,0,1,0-1.88,0v7H50.19V80.2a8.94,8.94,0,0,1,5.57-8.75l.06,0,4.47-1.86,4.83,17.25H63.27a.94.94,0,0,0,0,1.88h27a.94.94,0,0,0,.94-.94V80.2a11,11,0,0,0-5-9.57Zm-20,5.23L67,77.74l-.91,5.66-1.84-6.57h0l.22,0a.94.94,0,0,0,.56-.18l1.14-.84Zm2.38.83-.83-2,2-1.5,2.06,1.51-.74,2Zm4.14,1,.69-1.84,1.1.81a.94.94,0,0,0,.56.18l.22,0a.94.94,0,0,0,.22-.09l-1.87,6.67-.92-5.71Zm4.82-9-2.82,5.81-3.5-2.58L75,68.09a.94.94,0,0,0,.25-.77.92.92,0,0,0,0-.12v0l2.36,1.56ZM80.66,54V48.87a2.58,2.58,0,0,1,0,5.09ZM69.42,31.51h1A11.2,11.2,0,0,1,81.62,42.7v4.49a4.41,4.41,0,0,0-1-.21h0s0,0,0-.06v-.18l0,0v0l0-.05,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0-.05,0h0l-.06,0h0c-3.67-.83-4.78-5.46-4.79-5.5a.94.94,0,0,0-1.67-.34C69.3,46,60.23,46,60.08,46H59.8l0,0,0,0-.05,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0v0l0,0v.18s0,0,0,0v0a4.43,4.43,0,0,0-.9.19V42.7A11.2,11.2,0,0,1,69.42,31.51ZM57,51.41a2.59,2.59,0,0,1,2.13-2.55V54A2.59,2.59,0,0,1,57,51.41Zm4,3.12V47.89c2.4-.15,8.77-.94,12.86-5.23a8.72,8.72,0,0,0,4.9,5v6.84a7.93,7.93,0,0,1-7.92,7.92H68.94A7.93,7.93,0,0,1,61,54.53Zm7.92,9.8h1.92A9.78,9.78,0,0,0,73.35,64v3l-3.49,3.62-3.42-3.33a.92.92,0,0,0,0-.16V65.32h0V64a9.77,9.77,0,0,0,2.49.32Zm-4.36,2.72v.14a1,1,0,0,0,0,.28.94.94,0,0,0,.24,1l3.57,3.48-3.53,2.6-2.82-5.81,2.5-1.65Zm2.89,19.76,1.33-8.25H71l1.33,8.25Zm21.9,0H84v-7a.94.94,0,1,0-1.88,0v7H74.68l4.81-17.16,4.25,1.77.06,0a7.52,7.52,0,0,1,1.45.75h0a9,9,0,0,1,4.12,8v6.62Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M71,55.39a.94.94,0,0,0,0-1.88H70.3V51.34a.94.94,0,0,0-1.88,0v3.11a.94.94,0,0,0,.94.94Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCpPosterIcon);
export default __webpack_public_path__ + "static/media/CP-poster-icon.d0c68e37f3a685227ce446679ef36e0e.svg";
export { ForwardRef as ReactComponent };